import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
const PaymentFailed = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  return <div className="full-screen-center" style={{ textAlign: "center", gap: 12 }}>
      <h1 style={{ margin: 0 }}>Payment Failed</h1>
      <p style={{ margin: 0, color: "var(--text-3)", maxWidth: 480 }}>
        Your payment was cancelled or declined. You can try again from the upgrade modal.
        {orderId ? ` Order: ${orderId}` : ""}
      </p>
      <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
        <button className="btn-primary" onClick={() => navigate("/chat")}>Back to Chat</button>
        <button className="btn-ghost" onClick={() => navigate("/settings")}>Open Settings</button>
      </div>
    </div>;
};
var stdin_default = PaymentFailed;
export {
  stdin_default as default
};
